import { DepositPaymentStatusEnum, TransactionStatusEnum, TransferRequestStatusEnum } from '@shared/api';

export class ColorUtils {
  static getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';

    for (let i = 0; i < 6; i++) color += letters[Math.floor(Math.random() * 16)];

    return color;
  };

  static getDepositPaymentStatusStyles = (status?: DepositPaymentStatusEnum) => {
    switch (status) {
      case DepositPaymentStatusEnum.Completed:
        return { bg: 'bg-dark-emerald', text: 'text-emerald' };
      case DepositPaymentStatusEnum.Failed:
        return { bg: 'bg-light-carmine-pink', text: 'text-purple-pink' };
      case DepositPaymentStatusEnum.Rejected:
        return { bg: 'bg-light-carmine-pink', text: 'text-purple-pink' };
      case DepositPaymentStatusEnum.Cancelled:
        return { bg: 'bg-light-carmine-pink', text: 'text-purple-pink' };
      case DepositPaymentStatusEnum.Draft:
        return { bg: 'bg-dark-red-sand', text: 'text-red-sand' };
      case DepositPaymentStatusEnum.Returned:
        return { bg: 'bg-light-carmine-pink', text: 'text-purple-pink' };
      case DepositPaymentStatusEnum.Processing:
        return { bg: 'bg-dark-red-sand', text: 'text-red-sand' };
      default:
        return { bg: 'bg-light-gray', text: 'text-black' };
    }
  };

  static getTransferRequestStatusStyles = (status?: TransferRequestStatusEnum) => {
    switch (status) {
      case TransferRequestStatusEnum.Completed:
        return { bg: 'bg-emerald/10', text: 'text-emerald' };
      case TransferRequestStatusEnum.Cancelled:
        return { bg: 'bg-purple-pink/10', text: 'text-purple-pink' };
      case TransferRequestStatusEnum.WaitingForApproval:
        return { bg: 'bg-red-sand/10', text: 'text-red-sand' };
      case TransferRequestStatusEnum.Draft:
        return { bg: 'bg-red-sand/10', text: 'text-red-sand' };
      case TransferRequestStatusEnum.Scheduled:
        return { bg: 'bg-red-sand/10', text: 'text-red-sand' };
      default:
        return { bg: 'bg-red-sand/10', text: 'text-red-sand' };
    }
  };

  static getTransactionStatusStyles = (status?: TransactionStatusEnum) => {
    switch (status) {
      case TransactionStatusEnum.APPROVED:
        return { bg: 'bg-very-dark-emerald', text: 'text-emerald' };
      case TransactionStatusEnum.PENDING:
        return { bg: 'bg-very-dark-red-sand', text: 'text-red-sand' };
      case TransactionStatusEnum.DECLINED:
        return { bg: 'bg-very-dark-purple-pink', text: 'text-purple-pink' };
      default:
        return { bg: 'bg-light-gray/10', text: 'text-black' };
    }
  };
}
